import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import ServiceUnavailable from './components/service-unavailable/service-unavailable.component';
import ServiceUnAuthorized from './components/service-unauthorized/service-unauthorized.component';
import { CanDeactivateGuard } from './auth/can-deactivate-guard.service';
import { AuthGuard } from './auth/auth.guard';
import { PreloadSelectedModules } from './selective-preload-strategy';
import MainActivityLog from './components/activity-log/main-activity-log.component';
import { HybridInterconnectEmbed } from './components/hybrid-interconnect/hybrid-interconnect-embed';
import SitePairingEmbedComponent from './components/sitepairing/site-pairing-embed';
import { FleetEmbedComponent } from './components/fleet/fleet-embed';
import HcspDashboardEmbedComponent from './components/hcsp-dashboard/hcsp-dashboard-embed';

import DisasterRecoveryEmbed from './components/disaster-recovery/disaster-recovery-embed';
import AddEditNetworkDialog from './modules/networking/networking-vc/networks/dialogs/add-edit-network-dialog.component';
import AddEditImportNetworkDialog from './modules/networking/networking-vc/networks/import-network/add-edit-import-network-dialog.component';
import AddEditGatewayWizard from './modules/networking/networking-vc/gateways/dialogs/add-edit-gateway-wizard.component';
import { GatewayListing } from './modules/networking/networking-vc/gateways/listing/gateway-listing.component';
import { NetworkListing } from './modules/networking/networking-vc/networks/listing/network-listing.component';

import NetworkingView from './modules/networking/networking-vc/networking-view.component';
import NetworkingVcdView from './modules/networking/networking-vcd/networking-vcd.components';
import MigrationEmbed from '././components/migration/migration-embed';
import NetworkExtensionEmbed from './components/network-extension/network-extension-embed';
import NetworkExtensionEmbed2 from './components/network-extension2/network-extension-embed2';
import { ImportGatewayDialog } from './modules/networking/networking-vc/gateways/dialogs/import-gateway/import-gateway-dialog.component';
import DataProtection from './components/dataprotection/dataprotection.component';
import Compute from './components/compute/compute.component';
import { PublisherApp } from '../publisher/src/publisher-ui/publisher.component';
import { TroubleShootingApp } from '../troubleshooting/src/troubleshooting-ui/troubleshooting.component';
import { AlertApp } from '../alerts/src/alerts-ui/alerts.component';
import { DeploymentContainerLanding } from './components/administration-main/deployment-container/dc-landing.component'
import { InterConnectConfigurationLanding } from './components/administration-main/interconnect-configuration/icc-landing.component'
import { AuditLogApp } from '../auditlog/src/auditlog-ui/auditlog.component';
import { LoginComponent } from './auth/login.component';
import UnderlayEmbed from './components/underlay-app/underlay-app-embed';
@NgModule({
    imports: [
        RouterModule.forRoot([
            { path: 'dashboard', component: HcspDashboardEmbedComponent, canActivate: [AuthGuard], data: {type:'dashboard'} },
            { path: 'dashboard-hcsp', component: HcspDashboardEmbedComponent, canActivate: [AuthGuard], data: {type:'dashboard'} },
            { path: 'administration-activity-logs', component: HcspDashboardEmbedComponent, canActivate: [AuthGuard], data: {type:'activityLogs'} },
            { path: 'alerts', component: AlertApp, canActivate: [AuthGuard] },
            { path: 'activities', component: MainActivityLog, canActivate: [AuthGuard] },
            {
                path: '',
                redirectTo: '/login',
                pathMatch: 'full'
            },
            {
                path: 'inventory',
                loadChildren: './components/inventory-main/inventory.module#InventoryModule',
                canLoad: [AuthGuard],
                data: {
                    preload: true
                }
            },
            {
                path: 'services',
                loadChildren: './components/services-main/services.module#ServicesModule',
                canLoad: [AuthGuard]
            },
            {
                path: 'administration',
                loadChildren: './components/administration-main/administration.module#AdministrationModule',
                canLoad: [AuthGuard]
            },
            { path: 'unavailable', component: ServiceUnavailable, canActivate: [AuthGuard] },
            { path: 'unauthorized', component: ServiceUnAuthorized },
            { path: 'interconnect', component: HybridInterconnectEmbed, canActivate: [AuthGuard] },
            { path: 'connectivity-health', component: UnderlayEmbed, canActivate: [AuthGuard] },
            { path: 'sitepairing', component: SitePairingEmbedComponent, canActivate: [AuthGuard] },
            { path: 'fleet', component: FleetEmbedComponent, canActivate: [AuthGuard] },
            { path: 'dataprotection', component: DataProtection, canActivate: [AuthGuard] },
            {
                path: 'compute', component: Compute,
                canActivate: [AuthGuard]
            },
            /*   { path: 'upgradeapp', component: PublisherApp,
                    canActivate: [AuthGuard]},*/
            {
                path: 'networks', component: NetworkingVcdView,
                canActivate: [AuthGuard]
            },
            {
                path: 'networking', component: NetworkingView, canActivate: [AuthGuard],
                children: [
                    { path: '', component: NetworkingView, canActivate: [AuthGuard] },
                    {
                        path: 'network', component: NetworkListing, canActivate: [AuthGuard],
                        children: [
                            {
                                path: 'new', component: AddEditNetworkDialog,
                                canActivate: [AuthGuard]
                            },
                            {
                                path: 'edit/:id', component: AddEditNetworkDialog,
                                canActivate: [AuthGuard]
                            },
                            {
                                path: 'import', component: AddEditImportNetworkDialog,
                                canActivate: [AuthGuard]
                            },
                            {
                                path: 'edit-import/:id', component: AddEditImportNetworkDialog,
                                canActivate: [AuthGuard]
                            }
                        ]
                    },
                    {
                        path: 'gateways', component: GatewayListing,
                        canActivate: [AuthGuard],
                        children: [
                            {
                                path: 'new', component: AddEditGatewayWizard,
                                canActivate: [AuthGuard]
                            },
                            {
                                path: 'edit/:id', component: AddEditGatewayWizard,
                                canActivate: [AuthGuard]
                            },
                            {
                                path: 'import', component: ImportGatewayDialog,
                                canActivate: [AuthGuard]
                            }
                        ]
                    }
                ]
            },
            { path: 'network-extension-embed', component: NetworkExtensionEmbed, canActivate: [AuthGuard] },
            { path: 'network-extension-embed2', component: NetworkExtensionEmbed2, canActivate: [AuthGuard] },
            { path: 'migration-embed', component: MigrationEmbed, canActivate: [AuthGuard] },
            {
                path: 'disaster-recovery-embed', component: DisasterRecoveryEmbed,
                canActivate: [AuthGuard]
            },
            {
                path: 'troubleshooting', component: TroubleShootingApp,
                canActivate: [AuthGuard]
            },
            {
                path: 'upgradeapp', component: PublisherApp,
                canActivate: [AuthGuard]
            },
            {
                path: 'deploymentcontainer', component: DeploymentContainerLanding,
                canActivate: [AuthGuard]
            },
            {
                path: 'auditlogapp', component: AuditLogApp,
                canActivate: [AuthGuard]
            }
        ],
            { useHash: true, preloadingStrategy: PreloadSelectedModules, enableTracing: false })
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanDeactivateGuard,
        PreloadSelectedModules
    ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts